<template>
  <div class="plan-card flex min-h-96 shadow-none rounded-lg w-full">
    <div class="w-full h-full min-h-[200px] animate-pulse bg-grey-divider-subdued rounded"></div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PlanCardSkeleton',
};
</script>

<style></style>
